export const OrderStatus = ({ value, size = "small" }) => {
  const getStatusStyles = (status) => {
    switch (status) {
      case "Pending":
        return {
          bg: "bg-[#FE9F29]/10",
          text: "text-[#FE9F29]",
          border: "border-[#FE9F29]",
          label: "Pending",
        };
      case "Awaiting Payment":
      case "Under Review":
      case "Under Review by Admin":
      case "Awaiting Payment By Agent":
      case "Needs you to send a quote":
      case "Needs you to accept it":
      case "Needs you to review it":
      case "Review this request":
      case "Request received — Ops review":
      case "Ops must review eligibility":
      case "Ops must review this void":
      case "Ops must review this refund":
      case "Check airline if it can open":
      case "Request received — get the price":
      case "Request received":
      case "Request received — getting price":
      case "Getting airline price":
      case "Could not get price — check airline":
      case "Check airline for price":
      case "Enter quote from airline":
      case "Take over — enter quote from airline":
      case "Send to airline by hand":
      case "Void it on the airline site":
      case "Submit refund on airline site":
      case "Get airline numbers — then quote":
      case "Get price — then type the quote":
      case "Get price — then enter quote":
      case "Get airline price — then enter quote":
      case "Submit details change on airline site":
      case "Price failed — Ops must quote":
      case "Price failed — get airline numbers":
      case "Paid — send to airline":
      case "No extra pay — send to airline":
      case "Send to airline first":
      case "Send failed — do it by hand":
      case "Send failed — void it on airline site":
      case "Send failed — submit on airline site":
      case "Send failed — try again":
      case "Auto submission failed":
      case "VoidFailureSettled":
      case "VOID_FAILURE_SETTLED":
      case "Agent must pay":
      case "Bank transfer pending approval":
      case "Ops processing / quote":
      case "Accepted — check payment":
      case "Accepted — send to airline":
      case "Airline done — write the new ticket":
      case "Finish the ticket in Intraverse":
      case "Extra money taken — write the ticket":
      case "No money to move — write the ticket":
      case "Credit sent — write the ticket":
      case "Check with the airline":
      case "Working with the airline":
      case "Could not finish — try again":
      case "Need more information":
      case "Getting supplier price":
      case "Reversing payment":
      case "Releasing payment":
      case "Airline voided — settle money":
      case "Airline refunded — credit wallet":
      case "Settling money":
      case "Fee taken — credit balance":
      case "Balance credited":
      case "Wallet credited":
      case "ManualOpenTicketProcessing":
      case "MANUAL_OPEN_TICKET_PROCESSING":
      case "OpenTicketProcessingWithSupplier":
      case "OPEN_TICKET_PROCESSING_WITH_SUPPLIER":
      case "Needs review":
      case "Create quote":
      case "ManualReviewRequired":
      case "MANUAL_REVIEW_REQUIRED":
      case "ManualRefundProcessing":
      case "RefundQuoted":
      case "RefundAccepted":
      case "SupplierProcessing":
      case "Waiting for agent":
      case "Waiting for agent payment":
      case "Waiting for agent to accept quote":
      case "Waiting for agent to pay":
      case "Submit to airline":
      case "Send to airline":
      case "Sending to airline":
      case "Waiting on airline":
      case "Confirm re-issue":
      case "Credit agent wallet":
      case "AUTO_VOID_FAILED":
      case "AutoVoidFailed":
      case "VOID_REQUEST_SUBMITTED":
      case "VoidRequestSubmitted":
      case "MANUAL_VOID_PROCESSING":
      case "ManualVoidProcessing":
      case "AUTO_VOID_PROCESSING":
      case "AutoVoidProcessing":
      case "VOID_PROCESSING":
        return {
          bg: "bg-[#FE9F29]/10",
          text: "text-[#FE9F29]",
          border: "border-[#FE9F29]",
          label: value,
        };
      case "Processing":
        return {
          bg: "bg-[#FE9F29]/10",
          text: "text-[#FE9F29]",
          border: "border-[#FE9F29]",
          label: "Processing",
        };
      case "Awaiting Assignment":
      case "Awaiting Quote by Admin":
      case "Awaiting Re-Imbursement":
      case "Awaiting Submission to Airline":
      case "Awaiting Payment Confirmation":
      case "Awaiting ticketing":
      case "Awaiting Void":
      case "Awaiting Refund":
      case "Awaiting Change":
      case "Awaiting Cancellation":
      case "Awaiting Agent Confirmation":
      case "Awaiting Confirmation":
      case "Awaiting freeze approval":
      case "Not Paid":
        return {
          bg: "bg-[#FE9F29]/10",
          text: "text-[#FE9F29]",
          border: "border-[#FE9F29]",
          label: value,
        };
      case "Paid":
        return {
          bg: "bg-[#32CD32]/10",
          text: "text-[#32CD32]",
          border: "border-[#32CD32]",
          label: "Paid",
        };
      case "Failed":
        return {
          bg: "bg-[#FF0000]/10",
          text: "text-[#FF0000]",
          border: "border-[#FF0000]",
          label: "Failed",
        };
      case "Quote expired":
      case "NameChangeQuoteExpired":
      case "NAME_CHANGE_QUOTE_EXPIRED":
      case "DateChangeQuoteExpired":
      case "DATE_CHANGE_QUOTE_EXPIRED":
      case "RefundQuoteExpired":
      case "REFUND_QUOTE_EXPIRED":
        return {
          bg: "bg-[#FF0000]/10",
          text: "text-[#FF0000]",
          border: "border-[#FF0000]",
          label: "Quote expired",
        };
      case "Quote expired — enter a new one":
      case "Quote expired — quote again":
        return {
          bg: "bg-[#FF0000]/10",
          text: "text-[#FF0000]",
          border: "border-[#FF0000]",
          label: "Quote expired — quote again",
        };
      case "Failed — check next step":
      case "Failed — not refunded":
      case "Airline declined void":
      case "Airline declined change":
      case "Airline declined open ticket":
      case "Airline declined refund":
      case "Airline said no":
      case "Airline could not change it":
      case "Airline could not void it":
      case "Airline could not refund it":
      case "Agent declined":
      case "Agent declined quote":
      case "Agent withdrew":
      case "Airline done — money failed":
      case "Change failed — settled":
      case "Failed — money settled":
      case "Payment released":
      case "Payment reversed":
      case "Not eligible":
      case "Void failed — settled":
      case "Settlement failed":
      case "Could not start":
        return {
          bg: "bg-[#FF0000]/10",
          text: "text-[#FF0000]",
          border: "border-[#FF0000]",
          label: value,
        };
      case "Declined by Ops":
      case "Declined":
      case "Canceled":
      case "Cancelled":
      case "Expired":
      case "Rejected":
      case "DateChangeRequestDenied":
      case "DATE_CHANGE_REQUEST_DENIED":
      case "DateChangeRequestCanceled":
      case "DATE_CHANGE_REQUEST_CANCELED":
      case "DateChangeRequestCancelled":
      case "DATE_CHANGE_REQUEST_CANCELLED":
      case "VoidRequestDenied":
      case "VOID_REQUEST_DENIED":
      case "NameChangeRequestDenied":
      case "NAME_CHANGE_REQUEST_DENIED":
      case "RefundRequestDenied":
      case "REFUND_REQUEST_DENIED":
        return {
          bg: "bg-[#FF0000]/10",
          text: "text-[#FF0000]",
          border: "border-[#FF0000]",
          label: "Declined by Ops",
        };
      case "RefundDeclinedBySupplier":
      case "REFUND_DECLINED_BY_SUPPLIER":
        return {
          bg: "bg-[#FF0000]/10",
          text: "text-[#FF0000]",
          border: "border-[#FF0000]",
          label: "Airline declined refund",
        };
      case "DateChangeDeclinedBySupplier":
      case "DATE_CHANGE_DECLINED_BY_SUPPLIER":
      case "DateChangeFailureSettled":
      case "DATE_CHANGE_FAILURE_SETTLED":
        return {
          bg: "bg-[#FF0000]/10",
          text: "text-[#FF0000]",
          border: "border-[#FF0000]",
          label: "Airline declined change",
        };
      case "NameChangeDeclinedBySupplier":
      case "NAME_CHANGE_DECLINED_BY_SUPPLIER":
        return {
          bg: "bg-[#FF0000]/10",
          text: "text-[#FF0000]",
          border: "border-[#FF0000]",
          label: "Airline declined details change",
        };
      case "OpenTicketDeclinedBySupplier":
      case "OPEN_TICKET_DECLINED_BY_SUPPLIER":
        return {
          bg: "bg-[#FF0000]/10",
          text: "text-[#FF0000]",
          border: "border-[#FF0000]",
          label: "Airline declined open ticket",
        };
      case "Booked":
        return {
          bg: "bg-[#1E61DC]/10",
          text: "text-[#1E61DC]",
          border: "border-[#1E61DC]",
          label: "Booked",
        };
      case "Issued":
      case "Ticket issued":
        return {
          bg: "bg-[#009688]/10",
          text: "text-[#009688]",
          border: "border-[#009688]",
          label: "Ticket Issued",
        };
      case "Reissued":
        return {
          bg: "bg-[#0056a8]/10",
          text: "text-[#0056a8]",
          border: "border-[#009688]",
          label: value,
        };
      case "Completed":
      case "Success":
      case "RefundCompleted":
      case "REFUND_COMPLETED":
      case "VOID_COMPLETED":
      case "VoidCompleted":
      case "Ticket is OPEN":
      case "OpenTicketSuccessful":
      case "OPEN_TICKET_SUCCESSFUL":
      case "OpenTicketCompleted":
      case "OPEN_TICKET_COMPLETED":
        return {
          bg: "bg-[#009688]/10",
          text: "text-[#009688]",
          border: "border-[#009688]",
          label: value === "Ticket is OPEN" ? value : "Completed",
        };
      case "PendingTicketIssue":
        return {
          bg: "bg-[#ABAB01]/10",
          text: "text-[#ABAB01]",
          border: "border-[#ABAB01]",
          label: "Pending Ticket Issue",
        };
      case "AwaitingAdmin":
        return {
          bg: "bg-[#4B0082]/10",
          text: "text-[#4B0082]",
          border: "border-[#4B0082]",
          label: "Awaiting Admin",
        };
      case "AutoCanceled":
        return {
          bg: "bg-[#795548]/10",
          text: "text-[#795548]",
          border: "border-[#795548]",
          label: "Auto Cancelled",
        };
      case "Denied":
        return {
          bg: "bg-[#D32F2F]/10",
          text: "text-[#D32F2F]",
          border: "border-[#D32F2F]",
          label: "Denied",
        };
      case "Cancelled":
        return {
          bg: "bg-[#D32F2F]/10",
          text: "text-[#D32F2F]",
          border: "border-[#D32F2F]",
          label: "Cancelled",
        };
      case "AdminCancelledConfirmation":
        return {
          bg: "bg-[#D32F2F]/10",
          text: "text-[#D32F2F]",
          border: "border-[#D32F2F]",
          label: "Admin Cancelled Confirmation",
        };
      case "CustomerPaid":
        return {
          bg: "bg-[#00FF00]/10",
          text: "text-[#00FF00]",
          border: "border-[#00FF00]",
          label: "Customer Paid",
        };
      case "TicketCanceled":
        return {
          bg: "bg-[#E57373]/10",
          text: "text-[#E57373]",
          border: "border-[#E57373]",
          label: "Ticket Cancelled",
        };
      case "Refunded":
        return {
          bg: "bg-[#00BCD4]/10",
          text: "text-[#00BCD4]",
          border: "border-[#00BCD4]",
          label: "Refunded",
        };
      case "TicketCancelationRequested":
        return {
          bg: "bg-[#FF5722]/10",
          text: "text-[#FF5722]",
          border: "border-[#FF5722]",
          label: "TC Requested",
        };
      default:
        return {
          bg: "bg-gray-200",
          text: "text-gray-700",
          border: "border-gray-700",
          label: value || "Unknown Status",
        };
    }
  };

  const { bg, text, border, label } = getStatusStyles(value);

  const sizeClasses =
    size === "large" ? `text-sm px-4 py-2` : "text-xs px-2 py-1";

  return (
    <div
      className={`rounded-md mb-3 w-fit pb-1 text-center ${bg} ${
        size === "large" ? `border py-2 pb-[7px] px-2 ${border}` : ""
      }`}
    >
      <span className={`font-bold rounded-md ${text} ${sizeClasses} flex justify-start items-start text-start`}>
        {label}
      </span>
    </div>
  );
};

export default OrderStatus;
